import { useMemo, useState } from "react";
import { Modal, Button } from "flowbite-react";
import { ILead } from "../../../../types/lead.type";
import { formatDateAndTime } from "../../../../common/helpers/date.helpers";
import { deleteLeadDuplicate } from "@/common/services/leads.api";
import { useToastContext } from "@/common/components/ui/toast/toast.context";

type Props = {
  show: boolean;
  onCancel: () => void;
  info: ILead | null;
};

export default function DeleteDuplicateLeadModal({
  show,
  onCancel,
  info,
}: Props) {
  const { notifyError, notifySuccess } = useToastContext();
  const [reason, setReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formattedDate = useMemo(() => {
    try {
      if (!info?.createdAt) return "";
      return formatDateAndTime(info.createdAt);
    } catch {
      return "";
    }
  }, [info]);

  const handleConfirm = async () => {
    if (!info?._id) return;
    if (!reason || reason.trim().length === 0) return;

    setIsSubmitting(true);
    try {
      const data = { cpf: info?.cpf, reason };
      const result = await deleteLeadDuplicate(data);
      if (result.ok) {
        notifySuccess("Lead excluído com sucesso.");
      }
      if (!result.ok) {
        notifyError(result.message || "Erro ao excluir o lead.");
      }
    } catch (err) {
      console.error("Erro ao excluir:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onClose={onCancel} className="relative">
      <Modal.Header>
        <h2 className="text-xl font-semibold dark:text-black">Excluir lead?</h2>
      </Modal.Header>

      <Modal.Body>

        <p className="mb-4 text-base text-gray-700">
          <strong>Deseja realmente excluir este lead? Essa ação não poderá ser desfeita.</strong>
        </p>

        <div className="space-y-3">
          <div>
            <strong>Nome:</strong> {info?.name || "-"}
          </div>
          <div>
            <strong>WhatsApp:</strong> {info?.whatsapp || "-"}
          </div>
          <div>
            <strong>Criado em:</strong> {formattedDate || "-"}
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Motivo da exclusão:</label>
            <textarea
              className="w-full border rounded p-2"
              rows={4}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
            {!reason && (<p className="text-sm text-red-600 mt-1">O motivo é obrigatório.</p>
            )}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="flex justify-end gap-3">
        <Button
          color="failure"
          onClick={handleConfirm}
        //disabled={isSubmitting || !info?._id || !reason.trim()}
        >
          {isSubmitting ? "Excluindo..." : "Confirmar exclusão"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
